import { Col, Row } from "reactstrap";
import "./blogs.css";
import AllBlogs from "../../config/blogs.json";
import { frmatDateMonth, linkToBlog } from "../../utils/utils";
import { Link } from "react-router-dom";
function BlogLanding() {
  return (
    <Row className="blog_wrap_genric">
      <Col md="10" className="para_wrapper_blogs">
        <h1>Blogs</h1>
        <hr className="footer_hr" />
        <Row>
          {AllBlogs.blogs.map((blog) => {
            return (
              <Col key={blog.headline} md="6" className="blog_article_list">
                <Link className="link_product" to={`${linkToBlog(blog)}`}>
                  <div className="blogs_card">
                    <div className="blogs_img_wrapper">
                      <img src={blog.image_url} alt="blog" />
                    </div>
                    <div className="blog_card_info">
                      <p className="blog_card_headline">{blog.headline}</p>
                      <p className="blog_card_date">
                        {frmatDateMonth(blog.published_date)}
                      </p>
                    </div>
                  </div>
                </Link>
              </Col>
            );
          })}
        </Row>
      </Col>
    </Row>
  );
}

export default BlogLanding;
